<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div style="width: 90%; margin-top: -1cm">


        <el-button type="primary" @click="getMemberInfo" size="medium">查看我的信息</el-button>

        <div class="title1">个人信息</div>

        <div>
          <el-table :data="memberInfo">
            <el-table-column label="编号" prop="id"></el-table-column>
            <el-table-column label="用户名" prop="name"></el-table-column>
            <el-table-column label="注册时间" prop="registerTime"></el-table-column>
            <el-table-column label="积分" prop="points"></el-table-column>
          </el-table>
        </div>

        <hr>

        <div class="title1" style="margin-right: 32px;">积分天梯榜 (前10)</div>
        <div>
          <p>
            <router-link to="/guessNumber" class="btn btn-primary my-2 p-3 font-weight-bold">数字大侦探</router-link>
          </p>

          <el-table :data="tableData">
            <el-table-column label="用户名" prop="name"></el-table-column>
            <el-table-column label="编号" prop="points"></el-table-column>
          </el-table>
        </div>



      </div>
    </section>
  </main>
</template>

<script>

  import TheCourse from "../components/the-course";
  export default {
    name: 'memberInfo',
    components: {TheCourse},
    data: function () {
      return {
        memberInfo:[],
        tableData: [],
        queryParams: {
          id:'',
        }, // 用
      }
    },
    created() {
      let _this = this;
      _this.getMemberInfo();
      _this.getPointsRanking();
    },



    methods: {

      //更新排名
      search(){
        this.getPointsRanking()
      },

      getMemberInfo(){
        let _this = this;
        let loginMember = Tool.getLoginMember();
        if (Tool.isEmpty(loginMember)) {
          Toast.warning("请先登录");
          return;
        }
        _this.queryParams.id = loginMember.id;
        console.log("queryParams:", _this.queryParams.id);
        _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/member/getInfoById',
            _this.queryParams).then((response)=>{
          console.log("开始游戏：", response);
          _this.memberInfo = response.data;
          },
        )
        },

      getPointsRanking() {
        let _this = this;
        _this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/pointGame/getPointsRanking').then((response)=>{
          console.log("积分排名：", response);
          _this.tableData = response.data;
        }).catch((response)=>{
          console.log("error：", response);
        })
      },


    }
  }
</script>

<style>
  .title1{
    margin-bottom: 2rem;
    color: #fafafa;
    letter-spacing: 0;
    text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
    font-size: 2rem;
  }
  .title2{
    margin-bottom: 2rem;
    color: transparent;
    -webkit-text-stroke: 1px black;
    letter-spacing: 0.04em;
    font-size: 2rem;
  }
  .title {
    margin-bottom: 10px;
    font-size: 30px;
    color: #333;
    text-align: center;
  }

  .input-with-button-container {
    display: flex;
    align-items: center; /* 确保元素垂直居中对齐 */
    gap: 8px; /* 在两个元素间创建2字符（可以调整为所需的像素值）的间距 */
  }
</style>
